var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconAudioLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconAudio",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M1129.432 113v1694.148H936.638l-451.773-451.773h-315.45C76.01 1355.375 0 1279.365 0 1185.96V734.187c0-93.404 76.01-169.414 169.415-169.414h315.45L936.638 113h192.794Zm-112.943 112.943h-33.093l-418.68 418.68v630.901l418.68 418.68h33.093V225.944Zm655.488 135.114C1831.904 521.097 1920 733.77 1920 960.107c0 226.226-88.096 438.898-248.023 598.938l-79.851-79.85c138.694-138.695 214.93-323.018 214.93-519.087 0-196.183-76.236-380.506-214.93-519.2Zm-239.112 239.745c95.663 97.018 148.294 224.644 148.294 359.272s-52.631 262.254-148.294 359.272l-80.529-79.286c74.769-75.785 115.88-175.175 115.88-279.986 0-104.811-41.111-204.201-115.88-279.986Zm-981.092 76.914H169.415c-31.06 0-56.472 25.3-56.472 56.471v451.773c0 31.172 25.412 56.472 56.472 56.472h282.358V677.716Z",
      fillRule: "evenodd"
    })));
  }
}
IconAudioLine.glyphName = 'audio';
IconAudioLine.variant = 'Line';
IconAudioLine.displayName = 'IconAudioLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconAudioLine.propTypes = {
  ...SVGIcon.propTypes
};
IconAudioLine.allowedProps = [...SVGIcon.allowedProps];
export default IconAudioLine;
export { IconAudioLine };